<template>
  <CFooter class="fixed-footer">
    <div class="footer-left">
      <a class="footer-brand">Itermigo</a>
      <span class="footer-year">&copy; {{ new Date().getFullYear() }}</span>
    </div>
    <div class="footer-right">
      <span class="footer-powered">Powered by</span>
      <a class="footer-company">ZA</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped>
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 250px; /* Adjust to match the width of the side menu */
  width: calc(100% - 250px); /* Footer width is reduced by the side menu width */
  background-color: #f8f9fa; /* Matches your design */
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1); /* Adds shadow for visibility */
  z-index: 1000; /* Ensures it's above other elements */
  padding: 10px 20px; /* Adds spacing around content */
  display: flex; /* Flexbox for horizontal layout */
  justify-content: space-between; /* Pushes items to opposite ends */
  align-items: center; /* Vertically aligns items */
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
}

.footer-brand {
  font-weight: bold;
  font-size: 1.2rem;
  color: #000;
  text-decoration: none;
  margin-right: 10px;
}

.footer-year {
  font-size: 1rem;
  color: #000;
}

.footer-powered {
  font-size: 1rem;
  color: #000;
  margin-right: 5px;
}

.footer-company {
  font-weight: bold;
  font-size: 1rem;
  color: #007bff;
  text-decoration: none;
}
</style>
